import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import moment from 'moment';
import { api } from 'src/Api';

export default function Messagebox({ customer_id, getMessage }) {
  console.log('🚀 ~ Messagebox ~ getMessage:', getMessage);
  const token = localStorage.getItem('token');

  const [data, setdata] = useState([]);
  const [error, seterror] = useState([]);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    handleMessage();
  }, [customer_id, getMessage]);

  const handleMessage = () => {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const params = new URLSearchParams();
    params.append('customer_service_id', customer_id);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    const url = `${api.get_service_message}?${params.toString()}`;
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setdata(result?.data);
          console.log('response of messages', result);
        } else {
          seterror(result.message);
          console.log('error', result.message);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
      });
  };

  return (
    <Box
      sx={{
        height: '80vh',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        mt: 2,
        mb: 2,
        padding: 2,
        backgroundColor: '#ffffff',
        overflowY: data.length > 0 ? 'scroll' : 'hidden', // Sirf vertical scroll enable kiya
        overflowX: 'hidden', // Horizontal scroll bar ko hide kiya

        // Webkit-based browsers ke liye scroll bar style
        '&::-webkit-scrollbar': {
          width: '8px' // Scroll bar ki width set karna
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f0f0f0', // Scroll track ka background color
          borderRadius: '8px' // Track ko rounded look dena
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888888', // Scroll bar ka color
          borderRadius: '100px', // Thumb ko rounded look dena
          border: '2px solid #ffffff' // Scroll bar thumb ke aas-paas space dena
        },

        // Firefox ke liye scroll bar style
        scrollbarWidth: 'thin', // Scroll bar ko patla banana
        scrollbarColor: '#888888 #f0f0f0' // Scroll bar thumb aur track ke colors set karna
      }}
    >
      {data.map((message) => (
        <Box
          key={message.id}
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            mb: 1
          }}
        >
          <Box
            sx={{
              maxWidth: '90%',
              padding: 2,
              // backgroundColor: 'rgba(0, 0, 0, 0.05)',
              borderRadius: 1,
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
              alignItems: 'center',
              // textAlign: message.user_id === 0 ? 'right' : 'left', // Align based on userId
              // marginLeft: message.user_id === 0 ? 'auto' : 0, // Shift to the right if userId is 0
              // marginRight: message.user_id === 0 ? 0 : 'auto' // Shift to the left otherwise
              // textAlign: message.user_id === 0 ? 'left' : 'right',/
              marginLeft: message.user_id == 0 ? 0 : 'auto',
              marginRight: message.user_id == 0 ? 'auto' : 0,
              backgroundColor: message.user_id == 0 ? 'rgba(0, 0, 0, 0.05)' : '#DCF8C6'
            }}
          >
            <Typography variant="body2" color="text.primary" style={{ fontSize: 13 }}>
              {message.message}
            </Typography>

            <Typography
              variant="body2"
              color="text.primary"
              sx={{
                textAlign: 'right',
                fontSize: 10
                // textAlign: message.user_id === 0 ? 'right' : 'left'
              }}
            >
              {message.message_time}
            </Typography>
          </Box>
        </Box>
      ))}

      {/* {data?.length == 0 && loading && (
        <Box
          sx={{
            height: '100%',
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CircularProgress />
        </Box>
      )} */}
      {loading && (
        <Box
          sx={{
            position: 'fixed', // To make it overlay on the entire screen
            top: 0,
            left: 0,
            width: '100vw', // Full viewport width
            height: '100vh', // Full viewport height
            display: 'flex',
            justifyContent: 'center', // Center horizontally
            alignItems: 'center', // Center vertically
            backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: Add a light overlay background
            zIndex: 9999 // Ensure it appears above other elements
          }}

          // sx={{
          //   height: '100%',
          //   flex: 1,
          //   display: 'flex',
          //   justifyContent: 'center',
          //   alignItems: 'center'
          // }}
        >
          <CircularProgress />
        </Box>
      )}
      {data?.length == 0 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <Typography color={'#ccc'}>{error}</Typography>
        </Box>
      )}
    </Box>
  );
}
